import * as React from 'react'
import { PASSWORD_RESET_PATH } from 'paths'
import cx from 'classnames'
import { useHistory } from 'react-router-dom'
// TODO: Remove Section.module.scss file completely once new Account page is implemented
import SectionStyles from 'components/Settings/Section.module.scss'
import { handleProfileSave } from '../AccountUtils'
import SettingsStyles from 'components/Settings/SettingsModal.module.scss'
import { Button } from 'blaze-ui/Button/Button'
import { useModals } from 'almanac-ui/Modal'
import ToggleButton from 'common/ToggleButton/ToggleButton'
import { useIsBlaze } from 'hooks/useIsBlaze'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  profileInformation: { email_visible: boolean; email: string }
  setProfileInformation: (args: any) => void
}

const Login: React.FC<React.PropsWithChildren<Props>> = ({ profileInformation, setProfileInformation }) => {
  const { email, email_visible } = profileInformation
  const { closeModal } = useModals()
  const history = useHistory()
  const isAlmanac = !useIsBlaze()
  const { isMobile } = useResponsiveDesign()

  const handleCheckBoxChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target
    setProfileInformation({ email, email_visible: checked })
    await handleProfileSave({ profile_attributes: { email_visible: checked } })
  }

  const handlePasswordReset = () => {
    closeModal()
    history.push(PASSWORD_RESET_PATH)
  }

  return (
    <div>
      <form id="loginAndPassword" autoComplete={'off'}>
        <div>
          <div className={cx(SectionStyles.sectionFieldWrapper, SectionStyles.alignTop)}>
            <div className={SectionStyles.rowStyles}>
              <Heading level={5}>Email</Heading>
              {isAlmanac && (
                <div className={SectionStyles.middle}>
                  <div>
                    <span className={SectionStyles.spanLabel}>Visible on Profile</span>
                  </div>
                  <div>
                    <ToggleButton checked={email_visible} name="email" handleChange={handleCheckBoxChange} />
                  </div>
                </div>
              )}
            </div>
            <div className={cx(SectionStyles.sectionInput, SectionStyles.newStyles)}>
              <Text variant="secondary" color="var(--dark-60)">
                {email}
              </Text>
            </div>
          </div>
        </div>
        <div className={SettingsStyles.divider} />
        <div className={SectionStyles.sectionRow}>
          <div className={cx(SectionStyles.sectionFieldWrapper, SectionStyles.alignTop)}>
            <div className={SectionStyles.rowStyles}>
              <Heading level={5}>Password</Heading>
              <Button
                size={isMobile ? 'md' : 'lg'}
                variant="secondary"
                onPress={handlePasswordReset}
                data-test-id="reset-password"
              >
                Reset Password
              </Button>
            </div>
            <div className={cx(SectionStyles.sectionInput, SectionStyles.newStyles)}>
              <Text variant="secondary" color="var(--dark-60)">
                If you do not remember your password and are currently logged in, please log out to reset your password
                by clicking "Forgot" at {isAlmanac ? 'almanac.io/login' : 'app.blaze.ai/login'}.
              </Text>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default Login
